
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

@Component
export default class DlgGuestUpdate extends Vue {
  @Prop({ default: null }) guest!: any;
  @Prop({ default: false }) dialog!: boolean;

  @Getter('admin/ceos/all') ceos!: any;
  @Action('admin/guests/update') updateGuest!: any;
  @Action('admin/guests/read') readGuests!: any;
  @Action('admin/ceos/read') readCeos!: any;

  localGuest: any = {};
  loading: boolean = false;
  valid: boolean = true;
  emailRules: Array<Function> = [
    (v: string) => !!v || 'E-mail ist ein Pflichtfeld',
    (v: string) => /.+@.+/.test(v) || 'E-mail ist ungültig',
  ];
  genders: Array<Object> = [
    {
      text: 'Weiblich',
      value: 'female',
    },
    {
      text: 'Männlich',
      value: 'male',
    },
  ];

  mounted() {
    this.readCeos();
  }

  private async update() {
    if ((this.$refs.form as any).validate()) {
      this.loading = true;
      this.updateGuest(this.localGuest).then((success: boolean) => {
        this.loading = false;
        if (success) {
          this.readGuests();
          this.localGuest = {};
          this.$emit('updated');
          this.closeDialog();
        }
      });
    }
  }

  @Watch('dialog')
  onDialogChanged() {
    this.localGuest = JSON.parse(JSON.stringify(this.guest));
  }

  private closeDialog() {
    this.$emit('close');
  }
}
